<script setup lang="ts">
/**
 * The WELCOME ABOARD / ENLISTED moment: a navy enamel plate (`.k-header`) with
 * a medal and the words in gold game lettering, struck across the card for a
 * beat before the harbour takes over. Position and rotation use the `translate`
 * and `rotate` properties, so the slam (`StampSlam`, which animates
 * `transform`) never fights them.
 */
import GameIcon from '../kit/GameIcon.vue';
</script>

<template>
  <div class="k-header ribbon">
    <GameIcon name="medal" :size="48" />
    <span class="k-title gold word"><slot /></span>
    <GameIcon name="star" :size="36" />
  </div>
</template>

<style scoped>
.ribbon {
  --h: 64px;
  position: absolute;
  top: 40%;
  left: 50%;
  z-index: 3;
  width: max-content;
  max-width: 96%;
  translate: -50% -50%;
  rotate: -4deg;
  pointer-events: none;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.6)) drop-shadow(0 0 16px rgba(255, 210, 87, 0.45));
}

.word {
  font-size: clamp(1.3rem, 6vw, 1.9rem);
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
